import { render } from "./PdfViewer.vue?vue&type=template&id=49847ea0&scoped=true&ts=true"
import script from "./PdfViewer.vue?vue&type=script&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&lang=ts"

import "./PdfViewer.vue?vue&type=style&index=0&id=49847ea0&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49847ea0"]])

export default __exports__